var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSzereplkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 38,
    viewBox: "0 0 44 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0164 21.7217H14.9728L21.9946 28.3216L29.0164 21.7217ZM3.82616 12.1104C3.78418 3.62029 6.11428 0 7.77263 0C9.43099 0 11.7191 3.62029 11.7191 12.1531C11.7191 20.6859 9.36802 24.2955 7.77263 24.3061C6.17725 24.3168 3.78418 20.6859 3.78418 12.1531M31.7034 12.1531C31.7034 3.62029 34.0125 0 35.6603 0C37.3082 0 39.6173 3.62029 39.6173 12.1531C39.6173 20.6859 37.2977 24.3061 35.6603 24.3061C34.023 24.3061 31.7034 20.6859 31.7034 12.1531Z",
    fill: "#7C6CC9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8163 35.9999C7.77276 35.9999 2 27.6166 2 27.6059M42 27.4351C42 27.4351 36.0803 35.9785 21.8163 35.9785",
    stroke: "#7C6CC9",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSzereplkIcon);
export default __webpack_public_path__ + "static/media/SzereplőkIcon.ccfc145c9f439a57409f6d9a082f49be.svg";
export { ForwardRef as ReactComponent };